"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OriginSchema = exports.CampaignDataSchema = void 0;
const zod_1 = require("zod");
const _1 = require(".");
exports.CampaignDataSchema = zod_1.z.object({
    utmSource: _1.LongStringSchema.optional(),
    utmMedium: _1.LongStringSchema.optional(),
    utmCampaign: _1.LongStringSchema.optional(),
    utmTerm: _1.LongStringSchema.optional(),
    utmContent: _1.LongStringSchema.optional(),
});
exports.OriginSchema = exports.CampaignDataSchema.extend({
    httpReferer: _1.LongStringSchema.optional(),
});
//# sourceMappingURL=campaign-data.js.map